// School selection init
const schoolProvinceIDSelector = 'reward_form_submission_submission_data_school_province'; // 1st level
const schoolCityIDSelector = 'reward_form_submission_submission_data_school_city'; // 2nd level
const schoolDistrictIDSelector = 'reward_form_submission_submission_data_school_district'; // 3rd level
const schoolNameIDSelector = 'reward_form_submission_submission_data_school_name';

loadRegionList(schoolProvinceIDSelector, 'ID-62-0-0', false);
loadRegionList(schoolCityIDSelector, '', true);
loadRegionList(schoolDistrictIDSelector, '', true);
loadSchoolList(schoolNameIDSelector, '', true);

const $formSelectSchoolProvince = $('#' + schoolProvinceIDSelector);
$formSelectSchoolProvince.on('change', function () {
  let selectedRegionParentID = $formSelectSchoolProvince.find('option:selected').val();
  $('#' + schoolCityIDSelector).empty()
  loadRegionList(schoolCityIDSelector, selectedRegionParentID, false);
  $('#' + schoolDistrictIDSelector).empty()
  loadRegionList(schoolDistrictIDSelector, '', true);
  $('#' + schoolNameIDSelector).empty();
  loadSchoolList(schoolNameIDSelector, selectedRegionParentID, false);
})

const $formSelectSchoolCity = $('#' + schoolCityIDSelector);
$formSelectSchoolCity.on('change', function () {
  let selectedRegionParentID = $formSelectSchoolCity.find('option:selected').val();
  $('#' + schoolDistrictIDSelector).empty();
  loadRegionList(schoolDistrictIDSelector, selectedRegionParentID, false);
  $('#' + schoolNameIDSelector).empty();
  loadSchoolList(schoolNameIDSelector, selectedRegionParentID, false);
})

const $formSelectSchoolDistrict = $('#' + schoolDistrictIDSelector);
$formSelectSchoolDistrict.on('change', function () {
  let selectedRegionParentID = $formSelectSchoolDistrict.find('option:selected').val();
  $('#' + schoolNameIDSelector).empty();
  loadSchoolList(schoolNameIDSelector, selectedRegionParentID, false);
})

const $formSelectSchoolName = $('#' + schoolNameIDSelector);
$formSelectSchoolName.on('change', function () {
  let selectedSchoolName = $formSelectSchoolName.find('option:selected').val();
  if (selectedSchoolName === 'Lainnya') {
    $('.school-other').removeClass('d-none');
  } else {
    $('.school-other').addClass('d-none');
  }
})

function loadRegionList(selectID, parentID, readonly) {

  if (parentID === "" || parentID === undefined) return

  path_url = '/api/v1/regions';
  if (window.location.host === 'app.ruangguru.com') {
    path_url = '/form/api/v1/regions';
  } else {
    path_url = '/api/v1/regions';
  }

  const $select2Selector = $('#' + selectID);
  $select2Selector.select2({
    theme: 'bootstrap',
    ajax: {
      type: 'get',
      url: path_url + '?parent_id=' + parentID,
      dataType: 'json',
      data: function (params) {
        return {
          searchTerm: params.term // search term
        };
      },
      delay: 250,
      processResults: function (data) {
        return {
          results: $.map(data.data, function (item) {
            return {
              text: item.regionName,
              id: item.globalID
            }
          })
        };
      }
    }
  });

  $select2Selector.prop("readonly", readonly);
  const savedValue = Cookies.get(selectID);
  if (savedValue && parentID) {
    $.ajax({
      type: 'GET',
      url: path_url + '?parent_id=' + parentID,
      dataType: 'json'
    }).then(function (response) {
      const regionData = response.data;

      // Try to find the item in the result list
      const match = regionData.find(item => item.globalID == savedValue);

      if (match) {
        const option = new Option(match.regionName, match.globalID, true, true)
        $select2Selector.append(option).trigger('change');
      }
    });
  }
}

function loadSchoolList(selectID, regionID, readonly) {

  path_url = '/api/v1/schools';
  if (window.location.host === 'app.ruangguru.com') {
    path_url = '/form/api/v1/schools';
  } else {
    path_url = '/api/v1/schools';
  }

  const $select2Selector = $('#' + selectID);
  $select2Selector.addClass('school-selector');
  $select2Selector.select2({
    theme: 'bootstrap',
    ajax: {
      type: 'get',
      url: path_url + '?region_id=' + regionID,
      dataType: 'json',
      data: function (params) {
        return {
          query: params.term // search term
        };
      },
      delay: 250,
      processResults: function (data) {
        if (data.data.length > 0) {
          return {
            results: $.map(data.data, function (item) {
              return {
                text: concatSchoolText(item),
                id: item.serial
              }
            })
          };
        } else {
          if ($select2Selector.data("school-other") === false) {
            return { results: [] }
          } else {
            return {
              results: [{
                text: 'Lainnya',
                id: 'Lainnya'
              }]
            }
          }
        }
      }
    }
  });

  $select2Selector.prop("readonly", readonly);

  const savedValue = Cookies.get(selectID);
  if (savedValue && regionID) {
    $.ajax({
      type: 'GET',
      url: '/api/v1/schools?region_id=' + regionID,
      dataType: 'json'
    }).then(function (response) {
      const schoolData = response.data;

      // Try to find the item in the result list
      const match = schoolData.find(item => item.serial == savedValue);

      if (match) {
        const option = new Option(concatSchoolText(match), match.id, true, true)
        $select2Selector.append(option).trigger('change');
      }
    });
  }
}

async function getRegionByName(regionName, parentID) {
  const response = await fetch(`/api/v1/regions?parent_id=${parentID}&searchTerm=${regionName}`);
  const data = await response.json();
  if (data.data.length > 0) {
    return data.data[0];
  }
  return null
}

async function getSchoolByName(schoolName, regionID) {
  const response = await fetch(`/api/v1/schools?query=${schoolName}&region_id=${regionID}`);
  const data = await response.json();
  if (data.data.length > 0) {
    return data.data[0];
  }
  return null
}

$(async function () {
  let params = new URLSearchParams(window.location.search);
  if (!params.has('prefill_school_province')) {
    return;
  }

  var provinceRegion = await getRegionByName(params.get('prefill_school_province'), 'ID-62-0-0');
  if (!provinceRegion) {
    return;
  }
  $formSelectSchoolProvince.append(new Option(provinceRegion.regionName, provinceRegion.globalID, false, false)).trigger('change');
  $formSelectSchoolProvince.val(provinceRegion.globalID).trigger('change');

  if (!params.has('prefill_school_city')) {
    return;
  }

  var cityRegion = await getRegionByName(params.get('prefill_school_city'), provinceRegion.globalID);
  if (!cityRegion) {
    return
  }

  $formSelectSchoolCity.append(new Option(cityRegion.regionName, cityRegion.globalID, false, false)).trigger('change');
  $formSelectSchoolCity.val(cityRegion.globalID).trigger('change');

  if (!params.has('prefill_school_name')) {
    return;
  }

  var school = await getSchoolByName(params.get('prefill_school_name'), cityRegion.globalID);
  if (school) {
    $(`#${schoolNameIDSelector}`).append(new Option(school.name, school.serial, false, false)).trigger('change');
    $(`#${schoolNameIDSelector}`).val(school.serial).trigger('change');
  }
});

$('.school-selector').each(function() {
  if ($(this).attr('data-dependent-field-visibility') === 'hidden') {
    $(this).next(".select2-container").addClass('d-none');
  }
});

function concatSchoolText(item) {
  let schoolText = item.name;
  if (item.secondRegionName) {
    schoolText += ` - ${item.secondRegionName}`;
  }
  if (item.thirdRegionName) {
    schoolText += ` - ${item.thirdRegionName}`;
  }
  return schoolText
}
